__webpack_require__.p = "/event/2025/china2025/";